export default __webpack_public_path__ + "static/media/logo.bce79daa.png";